import * as React from 'react';
const DisabledContext = React.createContext(false);
export const DisabledContextProvider = ({ children, disabled }) => {
    const originDisabled = React.useContext(DisabledContext);
    return (<DisabledContext.Provider value={disabled || originDisabled}>
      {children}
    </DisabledContext.Provider>);
};
export default DisabledContext;
